// extracted by mini-css-extract-plugin
export var active = "_c5-7";
export var container = "_c5-0";
export var evenWidth = "_c5-4";
export var large = "_c5-5";
export var outlet = "_c5-8";
export var slide = "_c5-2";
export var small = "_c5-6";
export var tab = "_c5-3";
export var tabs = "_c5-1";